import qs from 'qs'
import To from 'await-to-js'
import Callback from './Callback'
import { wizStandardInstance } from './instance'

export default class ModelServer {
  // 删除配置模型
  static async deleteModelConfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/preload', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  static async createModelConfig(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/preload', payload))
    return Callback(err, res)
  }

  static async getPreloadLists(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/preload/configs?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }

  static async getPreloadEditList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/preload/edit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }

  // 获取实体
  static async getClassList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 懒加载获取目录树数据
  static async getTreeNodes(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Folder/tree-nodes?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 根据id获取目录树节点数据
  static async getTreeNodeById(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/Folder/${payload.id}`))
    return Callback(err, res)
  }
  // 删除目录树节点
  static async deleteTreeNodeById(payload) {
    const [err, res] = await To(wizStandardInstance.delete(`/api/std/Folder/${payload.id}`))
    return Callback(err, res)
  }
  // 编辑目录树节点
  static async putTreeNode(payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/Folder/${payload.id}`, payload))
    return Callback(err, res)
  }
  // 新增目录树节点(批量)
  static async addTreeNode(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Folder/many', payload))
    return Callback(err, res)
  }
  // 获取目录树数据所有
  static async getTreeAllNodes(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Folder/tree-all-nodes?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取模型列表数据
  static async getTypeDynamicTable(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/type-dynamic-table-paged-result', payload)
    )
    return Callback(err, res)
  }
  // 新增模型
  static async createModelFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/upload_files_to_document', payload)
    )
    return Callback(err, res)
  }
  // 新增模型V2
  static async createModelFileV2(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/upload_files_to_document_v2', payload)
    )
    return Callback(err, res)
  }
  // 删除模型
  static async deleteDynamicData(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassData/delete-dynamic-data', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 获取模型基础信息
  static async getDynamicTableDataById(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/dynamic-table-data-by-id?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取文件
  static async getDocumentFiles(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get_document_files?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除上传的模型文件
  static async deleteDocumentFiles(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(
        `/api/std/Document/delete_document_file?${qs.stringify(payload)}`,
        {
          data: payload,
        }
      )
    )
    return Callback(err, res)
  }
  // 上传模型文件
  static async uploadReleFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/upload_rele_file', payload)
    )
    return Callback(err, res)
  }
  // 保存模型基本信息
  static async saveDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/save-dynamic-table-data', payload)
    )
    return Callback(err, res)
  }
  // 获取文件流
  static async getFileContent(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/file/${payload.id}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 下载模板
  static async downloadTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/download-template', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导入
  static async importDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/import-dynamic-table-data', payload)
    )
    return Callback(err, res)
  }
  // 导出
  static async exportDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/export-dynamic-table-data', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 下载文档文件
  static async downloadDocumentFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/download_document_file', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 分析模型位号进行关联
  static async analysisModelTag(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/analysis-model-tag', payload)
    )
    return Callback(err, res)
  }
}
